import React from "react";
import Section from "@/components/ui/section";
import Image from "next/image";
export default function Values() {
  const data = [
    {
      title: "Equity",
      description:
        "Through all-encompassing strategies, we aim to dismantle social hierarchies. Besides, we also aim to minimize hierarchies within our organization as well. In order to promote a fair culture, we give particular attention to the needs of the excluded.",
      gif: "/images/about/equality.gif",
    },
    {
      title: "Dignity",
      description:
        "We respect and recognize each person's agency, autonomy and worth. Although the people we assist are among the most disadvantaged, we acknowledge their leadership and the labour they put into the fight against injustice and violence. We uphold reverence even when resolving disputes.",
      gif: "/images/about/dignity.gif",
    },
    {
      title: "Integrity",
      description:
        "We have a responsibility towards the community, survivors, and the partners who collaborate with us. We make it a point to communicate about our difficulties, successes, and failures which helps us to reflect and learn both from our own, as well as other people's experiences.",
      gif: "/images/about/integrity.gif",
    },
    {
      title: "Co-Creation",
      description:
        "We actively aim to draw the participation of the communities and survivors we deal with in, as well as the rest of our team, from advisors to field staff. As a result, we can innovate, improve our strategies, and develop our ability to expand our bandwidth for change.",
      gif: "/images/about/co-creation1.gif",
    },
    {
      title: "Transformative Leadership",
      description:
        "We foster courage in people and communities through our work so that those we collaborate with can become leaders, and facilitators of change.",
      gif: "/images/about/transformative-leadership.gif",
    },
  ];
  return (
    <Section variant="flat">
      <h2 className="text-blue text-center">Our Values</h2>
      <p className="text-center mt-3">
        In our work and interactions with both internal and external
        individuals, we uphold the following five core values:
      </p>
      <div className="flex flex-row flex-wrap items-start justify-center w-full md:gap-12 gap-10 lg:my-12 my-8">
        {data?.map((row, key) => (
          <Block data={row} key={"value" + key} />
        ))}
      </div>
      <div id="our-leadership"></div>
    </Section>
  );
}
const Block = ({ data }) => {
  const { title, description, gif } = data;
  return (
    <div className="flex flex-col lg:w-[calc(33.33%-48px)] md:w-[calc(50%-48px)] w-full items-center justify-start h-full gap-2">
      <div className="lg:h-24 h-20 lg:w-24 w-20 rounded-2xl flex flex-col shrink-0 justify-center items-center bg-[#F4F9FF] group-hover:bg-white transition-all duration-300 ease relative">
        <Image
          src={gif}
          alt={title}
          fill
          className="object-contain object-center p-5"
          sizes="(max-width: 479px) 479px,(max-width: 768px) 768px, (max-width: 1200px) 1200px,(max-width: 1920px) 1920px, 1000px"
        />
      </div>

      <p className="lg:text-lg text-base text-darkBlue font-bold text-center">
        {title}
      </p>
      <p className="text-text mb-2 text-justify ">{description}</p>
    </div>
  );
};
